const getTotal = (proforma: any) => {
  let total = 0;
  if (proforma?.vehicles) {
    proforma.vehicles.forEach((vehicle: any) => {
      total = total + vehicle?.prices?.inclusive / 1.18;
    });
  }
  return total;
};

const getProformaTotals: any = (proforma: any) => {
  let discount = 0;
  let vat = 0;
  const total = getTotal(proforma);
  if (proforma?.discount?.isPercentage) {
    discount = total * proforma?.discount?.value;
  } else {
    discount = proforma?.discount?.value;
  }
  vat = (total - discount) * proforma?.vat?.amount;

  const exchange = proforma?.source?.exchange;

  const unit = total - discount;

  const net = unit + vat;

  return { total, discount, vat, unit, net, exchange };
};

// const getDiscount = (proforma: any) => {
//   let value = 0;
//   const total = getTotal(proforma);
//   if (proforma?.discount?.isPercentage) {
//     value = total * proforma?.discount?.value;
//   } else {
//     value = proforma?.discount?.value;
//   }

//   return value;
// };

// const getUnit = (proforma: any) => {
//   const discount = getDiscount(proforma);
//   const total = getTotal(proforma);

//   const unit = total - discount;

//   return unit;
// };

export default getProformaTotals;
